import { c as _c } from "react/compiler-runtime";
import { Box, styled } from '@mui/material';
import { NativeVaultColor } from '@/theme/colorSchemes';
export const SnapshotIndicator = props => {
  const $ = _c(4);
  const bgColor = props.isNative ? NativeVaultColor : props.backgroundColor;
  let t0;
  if ($[0] !== bgColor || $[1] !== props.isPartial || $[2] !== props.sx) {
    t0 = props.isPartial ? <PartialSnapshotIndicator backgroundColor={bgColor} sx={props.sx} /> : <FullSnapshotIndicator backgroundColor={bgColor} sx={props.sx} />;
    $[0] = bgColor;
    $[1] = props.isPartial;
    $[2] = props.sx;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
const FullSnapshotIndicator = styled('div')((props: {
  backgroundColor: string | null;
  sx?: object;
}) => ({
  height: '12px',
  width: '12px',
  borderRadius: '50%',
  display: 'inline-block',
  minWidth: '12px',
  minHeight: '12px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: props.backgroundColor || 'gray',
  backgroundColor: props.backgroundColor || 'transparent',
  ...props.sx
}));
const PartialSnapshotIndicator = props => {
  const $ = _c(8);
  const t0 = `2px solid ${props.backgroundColor}`;
  let t1;
  if ($[0] !== props.sx || $[1] !== t0) {
    t1 = {
      height: "12px",
      width: "12px",
      borderRadius: "50%",
      display: "inline-block",
      minWidth: "12px",
      minHeight: "12px",
      border: t0,
      overflow: "hidden",
      ...props.sx
    };
    $[0] = props.sx;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.backgroundColor) {
    t2 = <Box sx={{
      marginTop: "-1.5px",
      marginLeft: "-3px",
      height: "5px",
      width: "12px",
      transform: "rotate(-45deg)",
      backgroundColor: props.backgroundColor
    }} />;
    $[3] = props.backgroundColor;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <Box sx={t1}>{t2}</Box>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};